import React from 'react';
import EmojiIcon from '#web-components/components/Icons/EmojiIcon';
import type { EmojiIconProps } from '#web-components/components/Icons/EmojiIcon/EmojiIcon';
// https://emojipedia.org/waving-hand/
export default function CitizenIcon(props: Omit<EmojiIconProps, 'children'> = {}) {
  return (
    <EmojiIcon {...props}>👋</EmojiIcon>
  );
}
